import React, { useState } from 'react';
import { Select } from 'triider-components';

import Modal from 'components/Modal';

import { ComentBox, Label, Coment } from './styles';

const ReportModal = ({
  isOpen, close, reasons, onFinish,
}) => {
  const [fields, setFields] = useState({});
  const changeField = ({ target: { name, value } }) => {
    setFields({ ...fields, [name]: value });
  };

  const finish = () => {
    onFinish(fields);
    setFields({});
  };

  return (
    <Modal
      padding="60px 90px"
      isOpen={isOpen}
      toggle={close}
      title="REPORTAR PROBLEMA"
      disabled={!fields.feedback_id}
      footer="Reportar problema"
      footerClick={finish}
    >
      <p>
        Aconteceu alguma coisa? Deixe um comentário explicando o que houve e, em breve, entraremos
        em contato com você!
      </p>
      <Select
        value={fields.feedback_id}
        name="feedback_id"
        size="smallBlock"
        arrowColor="greyDark"
        placeholder="Selecione o motivo"
        onChange={changeField}
        options={[
          { value: '', label: 'Selecione um motivo' },
          ...reasons.map(reason => ({ value: reason.id, label: reason.text })),
        ]}
      />
      <Coment>
        <Label>Deseja deixar um comentário?</Label>
        <ComentBox
          value={fields.comments}
          name="comments"
          hasValue={fields.comments}
          onChange={changeField}
          placeholder="Digite seu comentário..."
        />
      </Coment>
    </Modal>
  );
};

export default ReportModal;
